import { render } from "./DashboardPage.vue?vue&type=template&id=2ee3a592&scoped=true"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"

import "./DashboardPage.vue?vue&type=style&index=0&id=2ee3a592&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-2ee3a592"

export default script